import { Form, InputGroup } from 'react-bootstrap';
import { MAX_NUMBER } from '../../../constants/constants';
import { formatPercent } from '../../../utils/formatters';
import { useState } from 'react';
import { useAccessibleId } from '../common/hooks/useAccessibleId';
import { useFormValidated } from '../common/FormValidationContext';

const PercentageField = ({
  value,
  min,
  max,
  fieldName,
  onChange,
  readonly = false,
  disabled = false,
  required = false,
  isSubmitting
  }) => {

  // set defaults
  min = min? min: 0;
  max = max? max: MAX_NUMBER;
  
  const validated = useFormValidated();
  const [touched, setTouched] = useState(false);
  const fieldNameDisplay = fieldName ? fieldName : 'Percentage';
  const controlId = useAccessibleId(fieldNameDisplay);

  const getError = () => {
    if (!value) return `${fieldNameDisplay} is required.`;
    if (value > max || value < min) return `${fieldNameDisplay} must be between ${formatPercent(min)} and ${formatPercent(max)}.`;
    return null;
  };
  const errorMessage = getError();
  const isInvalid = required && (touched || validated) && !!errorMessage;

  return (
    <Form.Group>
      <InputGroup hasValidation>
        <Form.FloatingLabel label={<span className={required ? 'required-field': ''}>{fieldNameDisplay}</span>} controlId={controlId}>
          <Form.Control
            type="number"
            min={min}
            max={max}
            step="1"
            value={value}
            onChange={(e) => {
              setTouched(true);
              onChange(e.target.value);
            }}
            onBlur={() => setTouched(true)}
            onWheel={(e) => e.target.blur()}
            readOnly={readonly}
            disabled={disabled || isSubmitting}
            required={required}
            isInvalid={!!errorMessage && touched}
            className="rounded-end-0"
            placeholder=""
          />
        </Form.FloatingLabel>
        <InputGroup.Text className={isInvalid? 'bg-danger-subtle border-danger': ''}>%</InputGroup.Text>
      </InputGroup>
      <Form.Control.Feedback
        type="invalid"
        className={isInvalid ? 'd-block' : undefined}>
        {errorMessage}
      </Form.Control.Feedback>
      {readonly && <Form.Text muted>Auto-calculated</Form.Text>}
    </Form.Group>
)};

export default PercentageField;
